<template>
  <div class="page-content list-page">
    <div v-if="loading" class="text-center p-5">
      <i class="fas fa-spinner fa-spin fa-2x"></i>
      <p>Loading data...</p>
    </div>

    <div v-else class="page-content list-page">
      <div class="page-content-header with-button">
        <div class="page-title">
          Discounts for {{ category.name }}
        </div>
      </div>
      <div class="page-content-white">
        <div class="buttons">
          <div class="left">
            <a :href="categoriesRoute" class="button light-grey-button">
              <i class="fas fa-circle-left"></i>
              Back to categories
            </a>

            <div class="input-group q-ml-lg" style="display: inline-flex; width: auto">
              <span class="input-group-text">
                <i class="fas fa-search"></i>
              </span>
              <input
                  type="text"
                  class="form-control"
                  placeholder="Search dealers..."
                  v-model="searchQuery"
              >
            </div>
          </div>

          <button
              class="button button-primary"
              @click.prevent="saveDiscounts"
              :disabled="saving"
          >
            <i :class="saving ? 'fas fa-spinner fa-spin' : 'fas fa-circle-check'"></i>
            {{ saving ? 'Saving...' : 'Save' }}
          </button>
        </div>

        <div v-if="saveSuccess" class="alert alert-success mb-3">
          <i class="fas fa-check-circle"></i>
          Discounts for {{ category.name }} saved successfully!
        </div>

        <div v-if="saveError" class="alert alert-danger mb-3">
          <i class="fas fa-exclamation-circle"></i>
          {{ saveError }}
        </div>

        <div class="table-responsive">
          <table class="table list-table">
            <thead>
            <tr>
              <th>Photo</th>
              <th>Dealer name</th>
              <th>Discount, %</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(user, index) in filteredUsers">
              <tr :key="user.id">
                <td>
                  <img :src="user.img || '/images/no-avatar.jpg'"
                       class="avatar"
                       alt=""
                  />
                </td>
                <td>
                  {{ user.full_name }}
                </td>
                <td>
                  <input type="number"
                         v-model.number="discountValues[user.id]"
                         min="0"
                         step="1"
                         class="form-control"
                         style="max-width: 150px"
                  />
                </td>
              </tr>
              <tr class="spacer" :key="'spacer-' + user.id">
                <td colspan="5"></td>
              </tr>
            </template>
            <tr v-if="filteredUsers.length === 0">
              <td colspan="3" class="text-center py-4">
                <p v-if="users.length === 0">No users found</p>
                <p v-else>No users match your search</p>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    categoryId: {
      type: [Number, String],
      required: true
    },
    categoriesRoute: {
      type: String,
      required: true
    },
    csrfToken: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      saving: false,
      saveSuccess: false,
      saveError: null,
      category: {},
      users: [],
      discounts: {},
      discountValues: {},
      searchQuery: ''
    }
  },
  computed: {
    filteredUsers() {
      if (!this.searchQuery.trim()) {
        return this.users;
      }

      const query = this.searchQuery.toLowerCase();
      return this.users.filter(user => {
        return user.full_name.toLowerCase().includes(query);
      });
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;

      axios.get(`/products/categories/getDiscountData/${this.categoryId}`)
          .then(response => {
            const data = response.data;
            this.category = data.category;
            this.users = data.users;
            this.discounts = data.discounts;

            // Initialize discount values from the loaded discounts
            this.discountValues = {};
            this.users.forEach(user => {
              this.discountValues[user.id] = this.discounts[user.id] || 0;
            });
          })
          .catch(error => {
            console.error('Error loading data:', error);
            this.saveError = 'Failed to load data. Please try again.';
          })
          .finally(() => {
            this.loading = false;
          });
    },
    saveDiscounts() {
      this.saving = true;
      this.saveSuccess = false;
      this.saveError = null;

      const formData = {
        _token: this.csrfToken,
        discounts: this.discountValues
      };

      axios.post(`/products/categories/discounts/${this.categoryId}`, formData)
          .then(response => {
            this.saveSuccess = true;

            // Hide success message after 3 seconds
            setTimeout(() => {
              this.saveSuccess = false;
            }, 3000);
          })
          .catch(error => {
            console.error('Error saving data:', error);
            this.saveError = 'Failed to save discounts. Please try again.';
          })
          .finally(() => {
            this.saving = false;
          });
    }
  }
}
</script>

<style scoped>
.search-box {
  max-width: 300px;
}

.alert {
  padding: 10px 15px;
  border-radius: 4px;
}

.alert-success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.alert-danger {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}
</style>
